import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CancelaCobrosService } from "../../servicios/cancela-cobros.service";
import { MuestraMensaje } from '../../shared/utilerias/notificaciones/notificaciones.component';
import { CancelaCobros, BuscaCobros, CatMotivoCancelaciones, CatMotivosCancelacionCfdi } from "../../entidades/entidades";
import { CatMotivoCancelacionesService } from '../../servicios/cat-motivo-cancelaciones.service';
import { CatMotivosCancelacionCfdiService } from "app/servicios/cat-motivos-cancelacion-cfdi.service";
import { Privilegios } from 'app/entidades/entidades';
import { Router, RouterStateSnapshot } from '@angular/router';
import { RUsuarioNivelesService } from "app/servicios/r-usuario-niveles.service";
import { PrivilegiosService } from 'app/servicios/privilegios.service';
@Component({
  selector: "app-cancela-cobros",
  templateUrl: "./cancela-cobros.component.html",
  styleUrls: ["./cancela-cobros.component.css"]
})

export class CancelaCobrosComponent implements OnInit {
  muestraMensaje = new MuestraMensaje();
  cancelaCobrosForm: FormGroup;

  @Input('buscaCobro') buscaCobro: BuscaCobros;
  @Input('cancelaCobros') cancelaCobros: CancelaCobros;
  @Output('cancelaCobrosOutput') cancelaCobrosOutput: EventEmitter<CancelaCobros>;
  @Output() cerrarCancelarCobro = new EventEmitter();
  @Output() cerrarCancelarCobro2 = new EventEmitter<any[]>();

  cancelar = new CancelaCobros();
  catalogosForm: FormGroup;
  mensajeForm: FormGroup;
  catMotivosC: CatMotivoCancelaciones[];
  catMotivosCfdi: CatMotivosCancelacionCfdi[];
  motivosC: CatMotivoCancelaciones;
  motivosCfdi : CatMotivosCancelacionCfdi;
  checkedPago: boolean = false;
  checkedFactura: boolean = false;
  cambio: boolean = true;
  cambio1: boolean = true;
  activo: boolean = true;
  
  ocultar: boolean = false;

  conceptoCheck: number = 2;

  public id_usuario_cancela: any;
  public respuesstaC: any;

  public progressBar = false;
  showBar() {
    this.progressBar = true;
  }
  public colorC: boolean;
  privilegios: any[] = [];
  privilegioCancelaFactura: Boolean = false;
  privilegioCancelaPago: Boolean = false;



  constructor(
    private router: Router,
    private formBuilder: FormBuilder,
    private cancelaCobrosService: CancelaCobrosService,
    private catMotivoCancelacionesService: CatMotivoCancelacionesService,
    private catMotivosCancelacionCfdiService: CatMotivosCancelacionCfdiService,
    private rUsuarioNivelesService: RUsuarioNivelesService,
    private privilegiosService: PrivilegiosService,
    
  ) {
    this.cancelaCobrosOutput = new EventEmitter(),
      this.id_usuario_cancela = JSON.parse(localStorage.getItem('currentUser'));
  }

  async canActivate(state: RouterStateSnapshot) {

  }
  ngOnInit() {
    console.log("inicia cancelacion");
    
    this.getPrivilegios();
    this.getAllCatMotivoCancelaciones();
    this.getAllCatMotivoCancelacionCfdi();
    this.cancelaCobrosForm = this.formBuilder.group({
      usuarioCancela: [undefined],
      contrasenia: [undefined],
      folio: [undefined],
      // serie: [undefined],
      uuid: [undefined],
      observaciones: [undefined]

    });
    this.cancelar.conceptoCancelar = 2;
    // this.cancelar.idUsuarioCancela =  this.id_usuario_cancela.id;

    if (this.buscaCobro) {
      this.cancelaCobrosForm.patchValue({
        uuid: this.buscaCobro.uuid,
        folio: this.buscaCobro.folio,
        // serie: this.buscaCobro.serie
      });
    }

    this.catalogosForm = this.formBuilder.group({
      id: [undefined],
    });

    this.mensajeForm = this.formBuilder.group({
      mensaje_: [undefined],
    });
  }
  async ngOnChanges() {
    this.cancelaCobrosForm = this.formBuilder.group({
      usuarioCancela: [undefined],
      contrasenia: [undefined],
      folio: [undefined],
      // serie: [undefined],
      uuid: [undefined],
      observaciones: [undefined]

    });
    if (this.buscaCobro) {
      this.cancelaCobrosForm.patchValue({
        uuid: this.buscaCobro.uuid,
      });
    }
  }

  //====================================================
  //Función de muestra.
  //====================================================


  // ====================================================
  // Metodos para obtener datos del servicio
  // ====================================================
  async CancelarCobros() {
    try {
      this.progressBar = true;
      this.cancelar = this.cancelaCobrosForm.value;
      await this.llenaEntidad();
      debugger;
      this.progressBar = true;
      
      const datoretorno = await this.cancelaCobrosService
        .add(this.cancelar)
        .toPromise();
      if (datoretorno)
        this.respuesstaC = datoretorno;
      console.log(this.respuesstaC);
       
      if (this.respuesstaC.error === true) {
        this.mensajeForm.patchValue({
          mensaje_: this.respuesstaC.errorDesc
        });
        this.progressBar = false;
        this.colorC = true;
      } else {
        this.cancelaCobrosForm.reset();
        this.mensajeForm.patchValue({
          mensaje_: 'CANCELACION EXITOSA'
        });
        this.colorC = false;
        this.progressBar = false;
      }
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      this.progressBar = false;
      console.log("Paso por addCancelaCobros");
    }
  }
  async llenaEntidad() {
    try {
      // Limpiar el mensaje anterior y el color al iniciar la validación
      this.mensajeForm.patchValue({ mensaje_: '' });
      this.colorC = false; 
      if (!this.cancelaCobrosForm.value.usuarioCancela) 
        throw new Error('Ingrese un usuario para realizar la cancelación');
      if (!this.cancelaCobrosForm.value.contrasenia) 
          throw new Error('Ingrese la contraseña del usuario que realiza la cancelación');    
      if (this.buscaCobro.folio != this.cancelaCobrosForm.value.folio)
        throw new Error('El folio ingresado no coincide con el seleccionado');
      console.log("this.motivosCfdi", this.motivosCfdi);
      
      if (!this.motivosC && !this.motivosCfdi)
        throw new Error('Seleccione un motivo de cancelación');
      if (!this.checkedFactura && !this.checkedPago)
        throw new Error('Seleccione un opcion');

      this.cancelar.idCobro = this.buscaCobro.id;
      if(this.checkedPago){
        this.cancelar.idMotivoCancelacion = this.motivosC.id;
      }
      if(this.checkedFactura && !this.checkedPago){
        console.log("this.motivosCfdi abc", this.motivosCfdi);
        
        this.cancelar.idMotivoCancelacion = this.motivosCfdi.id;
      }
      this.cancelar.conceptoCancelar = this.conceptoCheck;
      this.cancelar.cancelar = false ;
    } catch (e) {
      this.progressBar = false;
      this.mensajeForm.patchValue({
        mensaje_: e.message
      });
      this.colorC = true;
      throw e;
    } finally {
      console.log("Paso por addCancelaCobros");
    }
  }

  async getCancelaCobros(id: number) {
    try {
      const datoRetorno = await this.cancelaCobrosService
        .getSingle(id)
        .toPromise();
      this.cancelaCobrosForm.patchValue(datoRetorno);
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getCancelaCobros");
    }
  }

  async getAllCancelaCobros() {
    try {
      const datoRetorno = await this.cancelaCobrosService.getAll().toPromise();
      
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllCancelaCobros");
    }
  }
  async getAllCatMotivoCancelaciones() {
    try {
      const datoRetorno = await this.catMotivoCancelacionesService.getAll().toPromise();
      this.catMotivosC = datoRetorno;
      this.catMotivosC.unshift({ numRow: 0, id: 0, descripcion: 'SELECCIONA...', baja: false, cambio: false });
      
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllCatMotivoCancelaciones");
    }
  }
  async getAllCatMotivoCancelacionCfdi() {
    try {
      const datoRetorno = await this.catMotivosCancelacionCfdiService.getAll().toPromise();
      this.catMotivosCfdi = datoRetorno;
      this.catMotivosCfdi.unshift({ numRow: 0, id: 0, descripcion: 'SELECCIONA...', baja: false, cambio: false,clave : null });
      
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getAllCatMotivoCancelaciones");
    }
  }
 
  async change() {
    console.log("change", this.checkedPago);
      this.cancelar.conceptoCancelar == 2
    if (this.cancelaCobrosForm.value.uuid != null) 
      this.checkedFactura = true;
    if (this.cancelar.conceptoCancelar == 2)
      this.conceptoCheck = 2;
  }

  async change1() {
    console.log("this.cancelar.conceptoCancelar", this.checkedFactura);
    
    this.checkedPago = false;
    this.cancelar.conceptoCancelar = 1;
    this.conceptoCheck = 1;
  }

  async getPrivilegios() {
    try {

      let objUrl = new Privilegios();
      objUrl.descripcion = this.router.url + '/cancela-factura';
      let cancelaFactura = await this.privilegiosService.GetPrivilegioByRoute(objUrl).toPromise();
      this.privilegioCancelaFactura = cancelaFactura?true:false;

      objUrl.descripcion = this.router.url + '/cancela-pago';
      let cancelaPago = await this.privilegiosService.GetPrivilegioByRoute(objUrl).toPromise();
      this.privilegioCancelaPago = cancelaPago?true:false;

    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getPrivilegios");
    }
  }


}